import moment from "moment";

export const destructure = (data) => {
    //console.log('------------', data);
    if (data && typeof data === 'string') {
        if (data?.includes('DAILY')) {
            return dailyStructure(data)
        } else if (data?.includes('WEEKLY')) {
            return weeklyStructure(data)
        } else if (data?.includes('MONTHLY')) {
            return monthlyStructure(data)
        } else if (data?.includes('YEARLY')) {
            return yearlyStructure(data)
        }
    }
}

const dailyStructure = (val) => {
    const data = val?.split(';')
    // console.log(data);
    const obj = {
        repeat: {},
        type: 'DAILY',
        fullData: true,
        enddate: '',
    };
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    // console.log(obj, '------>');
    return obj;
}

const weeklyStructure = (val) => {
    const data = val?.split(';');
    const obj = {
        repeat: {},
        week: [],
        type: 'WEEKLY',
        fullData: true,
        enddate: '',
    };
    // console.log(data);
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? ''
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                obj.week = wordSplit[1] ? wordSplit[1].split(',') : ''
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    return obj;
}

const monthlyStructure = (val) => {
    // console.log(val?.includes('BYMONTHDAY'))
    if (val?.includes('BYMONTHDAY')) {
        return mothlyByMonthDay(val);
    } else if (val?.includes('BYDAY')) {
        return mothlyByDay(val);
    }
}

const mothlyByMonthDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    const obj = {
        repeat: {},
        type: 'MONTHLY',
        onday: '',
        subtype: 'onday',
        enddate: '',
        fullData: true
    };
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTHDAY') {
                obj.onday = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    return obj
}

const mothlyByDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    const obj = {
        repeat: {},
        type: 'MONTHLY',
        onthe: {
            position: '',
            day: ''
        },
        subtype: 'onthe',
        enddate: '',
        fullData: true
    };
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                obj.onthe.day = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYSETPOS') {
                obj.onthe.position = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    return obj
}

const yearlyStructure = (val) => {
    if (val?.includes('BYMONTHDAY')) {
        return yearlyByMonthDay(val);
    } else if (val?.includes('BYDAY')) {
        return yearlyByDay(val);
    }
}

const yearlyByMonthDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    const obj = {
        repeat: {},
        type: 'YEARLY',
        on: {
            position: '',
            month: ''
        },
        subtype: 'on',
        enddate: '',
        fullData: true
    };
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTHDAY') {
                obj.on.position = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTH') {
                obj.on.month = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    return obj
}

const yearlyByDay = (val) => {
    const data = val?.split(';');
    // console.log(data);
    const obj = {
        repeat: {},
        type: 'YEARLY',
        onthe: {
            position: '',
            day: '',
            month: ''
        },
        subtype: 'onthe',
        enddate: '',
        fullData: true
    };
    if (data?.length > 0) {
        data?.forEach(item => {
            const wordSplit = item?.split('=');
            if (wordSplit?.length > 0 && wordSplit[0] === 'FREQ') {
                obj.repeat.type = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'INTERVAL') {
                obj.repeat.on = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYDAY') {
                obj.onthe.day = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYSETPOS') {
                obj.onthe.position = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'BYMONTH') {
                obj.onthe.month = wordSplit[1] ?? '';
            } else if (wordSplit?.length > 0 && wordSplit[0] === 'UNTIL') {
                obj.enddate = wordSplit[1] ? convertDateToLocal(wordSplit[1]) : ''
                // console.log(convertDateToLocal(wordSplit[1]))
            }
        })
    }
    return obj
}


const convertDateToLocal = (date) => {
    if (date) {
        const validDate = moment(date, 'YYYY/MM/DDTHH:mm:ssZ', true);
        // console.log(validDate.isValid(), 'valide');
        if (validDate.isValid()) {
            const local = moment.utc(date, 'YYYY/MM/DD HH:mm:ss');
            return local.local().format('MM/DD/YYYY');
        } else {
            // console.log('outside')
            return moment(date).format('YYYY-MM-DD');
        }
    } else {
        return '';
    }
}
